export const EMPLOYEE_INFORMATION_CHANGES_REPORT_LOAD = 'EMPLOYEE_INFORMATION_CHANGES_REPORT_LOAD'
export const EMPLOYEE_INFORMATION_CHANGES_REPORT_LOAD_PENDING =
  'EMPLOYEE_INFORMATION_CHANGES_REPORT_LOAD_PENDING'
export const EMPLOYEE_INFORMATION_CHANGES_REPORT_LOAD_FULFILLED =
  'EMPLOYEE_INFORMATION_CHANGES_REPORT_LOAD_FULFILLED'
export const EMPLOYEE_INFORMATION_CHANGES_REPORT_LOAD_REJECTED =
  'EMPLOYEE_INFORMATION_CHANGES_REPORT_LOAD_REJECTED'
